import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Leave Request
export const createLeaveRequest = createAsyncThunk(
  'leaveRequests/create',
  async (LeaveRequestData: Omit<any, 'Id'>, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/leaverequest', LeaveRequestData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create leave request');
    }
  }
);

// Update Leave Request
export const updateLeaveRequest = createAsyncThunk(
  "leaveRequests/update",
  async ({ leaveRequestId, data }: { leaveRequestId: number; data: any }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(
        `/leaverequest/${leaveRequestId}`,
        data, 
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Failed to update leave request");
    }
  }
);
  
// Delete Leave Request
export const deleteLeaveRequest = createAsyncThunk(
  'leaveRequests/delete',
  async (leaveRequestId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/leaverequest/${leaveRequestId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete leave request');
    }
  }
);

// Fetch Leave Request by ID
export const fetchLeaveRequestById = createAsyncThunk(
  'leaveRequests/fetchById',
  async (leaveRequestId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/leaverequest/${leaveRequestId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch leave request');
    }
  }
);

export const fetchLeaveRequestByEmployeeId = createAsyncThunk(
  'leaveRequests/fetchByEmployeeId',
  async (employeeId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/leaverequest/${employeeId}/employee`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch leave request');
    }
  }
);
export const fetchEmployeeLeaveAssignById = createAsyncThunk(
  'leaveRequests/fetchByEmployeeassignleaveId',
  async (employeeId: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/leaverequest/${employeeId}/assignleave`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch leave request');
    }
  }
);


// Fetch All Leave Requests
export const fetchAllLeaveRequests = createAsyncThunk(
  'leaveRequests/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/leaverequest');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch leave requests');
    }
  }
);
export const fetchAllLeaveRequestsWithCancelation = createAsyncThunk(
  'leaveRequests/fetchAllwithcancellation',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/leaverequest/withcancelation');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch leave requests');
    }
  }
);

export const fetchLeaveRequestBySupervisor = createAsyncThunk(
  'leaveRequest/fetchLeaveRequestBySupervisor',
  async (
    { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(
        `/leaverequest/superwiser/${supervisorId}`,
        { params: { includeSelf } }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || 'Failed to fetch leave requests by supervisor'
      );
    }
  }
);
export const fetchAllLeaveCancellationRequests = createAsyncThunk(
  'leaveRequests/fetchAllCancelleave',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/leaverequest/cancellationrequest/all/cancellation');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch leave Cancellation requests');
    }
  }
);

export const UpdateLeaveCancellation = createAsyncThunk(
  'leaveRequests/updateCancelleave',
  async ({leaverequestId , data} : any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/leaverequest/cancellation/update/${leaverequestId}` , data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch leave Cancellation requests');
    }
  }
);

export const fetchLeaveCancellationRequestBySupervisor = createAsyncThunk(
  'leavecancellationrequest/fetchLeaveCancellationRequestBySupervisor',
  async (
    { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(
        `/leavecancellationrequest/supervisor/${supervisorId}`, 
        { params: { includeSelf } }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || 'Failed to fetch cancellation leave requests by supervisor'
      );
    }
  }
);

export const fetchHierarchyLeaveRequests = createAsyncThunk(
  "leave/fetchHierarchyLeaveRequests",
  async ({useRouteId, includeSelf = false}: {useRouteId: number; includeSelf?: boolean},
    { rejectWithValue }
)=>{
    try {
      const response = await employeeServiceApiInstance.get(`/hierarchy/${useRouteId}?includeSelf=${includeSelf}`);
      return response.data.data; 
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message || "Server error");
    }
  }
);
